export const GA_OTHER_JOBS_ACTION = "job_detail__other_jobs";
export const GA_SHOW_OTHER_JOBS_ACTION = "job_detail__other_jobs_show";
export const APP_OTHER_JOBS_ACTION = "tap_job_detail__other_jobs";
export const APP_OTHER_JOBS_SHOW_ACTION = "imp_job_detail__other_jobs";
